import { AllowanceLoader } from './AllowanceLoader';

export const allowanceLoader: { (token?: string): AllowanceLoader } = (token) =>
  new AllowanceLoader(token);
